import { useCallback } from 'react';

const useScrollPage = (top?: number, selector?: string) => {
  return useCallback(() => {
    const container = selector ? document.querySelector(selector) : null;
    let y = 0;

    if (container !== null) {
      if (container instanceof HTMLElement) {
        y = container.offsetTop;
      }
    }

    if (top !== undefined) {
      window.scrollTo({
        left: 0,
        top,
        behavior: 'smooth',
      });
    } else if (y) {
      window.scrollTo({
        left: 0,
        top: y,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [
    document,
    window,
    top,
  ]);
};

export default useScrollPage;
